import { React, Fragment, memo, useEffect, useState } from 'react'

import {
  HeadingText,
  BodyText,
  Divider,
  Button,
  Row,
  Col,
  Link,
  V2ContactUsIcon,
  Checkbox,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomImpression, fptiCustomClick } from '../../../utils'
import {
  PYPL_CONTACTUS_URL,
  PRIVACY_STATEMENT_LINK,
} from '../../../constants/constants'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import asASlide from '../../common/as-a-slide'
import serverData from '../../../utils/server-data'

const DataDeletion = memo((props) => {
  const deletionFpti = DATAPRIVACY_FPTI.DELETION

  const [impressionDone, setImpressionDone] = useState(false)
  const { onModalNavigate } = props
  const [confirmCheckbox, setConfirmCheckbox] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [privacyURL, setPrivacyURL] = useState('')

  const handleContinueClick = (event) => {
    event.preventDefault()
    if (confirmCheckbox) {
      setShowAlert(false)
      fptiCustomClick(deletionFpti.CONTINUE_BTN)
      onModalNavigate(1)
    } else {
      setShowAlert(true)
    }
  }
  const onClickPrivacyLink = (event) => {
    event.preventDefault()
    fptiCustomClick(deletionFpti.PRIVACY_LINK)
    location.href = privacyURL
  }
  const onClickContactUs = (event) => {
    event.preventDefault()
    fptiCustomClick(deletionFpti.CONTACTUS_LINK)
    location.href = PYPL_CONTACTUS_URL
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(deletionFpti.IMPRESSION)
    }

    //set privacylink url
    let privacyLink = `https://${serverData.cdnPayPalDomain}${PRIVACY_STATEMENT_LINK}`
    setPrivacyURL(privacyLink)
  }, [])

  const handleConfirmCheckbox = (event) => {
    let checkedValue = event.target.checked
    setConfirmCheckbox(checkedValue)
  }

  return (
    <Fragment>
      <HeadingText id="dataDeletionHeader" size="lg">
        <Message id="dataErasure.section.heading" />
      </HeadingText>
      <BodyText className="dataPrivacy-row">
        <Message id="dataErasure.section.description" />
      </BodyText>
      <Divider secondary theme="v2" />
      <Row className="dataPrivacy-row">
        <Col>
          <HeadingText size="sm">
            <Message id="dataErasure.section.deletionQuestion" />
          </HeadingText>
        </Col>
      </Row>
      <Row className="dataDeletion-list">
        <Col>
          <ul className="dataDeletion-listOrder">
            <li className="dataDeletion-listOrder-item">
              <BodyText className="dataDeletion-textItem">
                <Message id="dataErasure.section.firstPoint" />
              </BodyText>
            </li>
            <li className="dataDeletion-listOrder-item">
              <BodyText className="dataDeletion-textItem">
                <Message id="dataErasure.section.secondPoint" />
              </BodyText>
            </li>
            <li className="dataDeletion-listOrder-item">
              <BodyText className="dataDeletion-textItem">
                <Message id="dataErasure.section.thirdPoint" />
              </BodyText>
            </li>
            <li className="dataDeletion-listOrder-item">
              <BodyText className="dataDeletion-textItem">
                <Message id="dataErasure.section.fourthPoint" />
              </BodyText>
            </li>
          </ul>
        </Col>
      </Row>
      <Divider secondary theme="v2" />
      <div className="dataDeletion-msg-info">
        <BodyText className="dataPrivacy-row">
          <Message
            id="dataErasure.section.deletionNoteWithLink"
            link={(innerMessage) => (
              <Link
                href={privacyURL}
                onClick={onClickPrivacyLink}
                id="privacy_statment_link"
                theme="v2"
              >
                {innerMessage}
              </Link>
            )}
          />
        </BodyText>
        <BodyText>
          <Message id="dataErasure.section.deletionInfo" />
        </BodyText>
      </div>
      <div className="dataDeletion-contactus">
        <V2ContactUsIcon size="sm" />

        <BodyText className="dataDeletion-contactus-info">
          <Message
            id="dataErasure.section.contactLink"
            link={(innerMessage) => (
              <Link
                href={PYPL_CONTACTUS_URL}
                onClick={onClickContactUs}
                id="contactus_link"
                theme="v2"
              >
                {innerMessage}
              </Link>
            )}
          />
        </BodyText>
      </div>
      <Divider secondary theme="v2" />

      <Row>
        <Col>
          <Checkbox
            theme="v2"
            label={<Message id="dataErasure.section.confirmCheckbox" />}
            checked={confirmCheckbox}
            name="confirmCheckbox"
            id="delete_confirm_checkbox"
            error={showAlert}
            errorText={<Message id="dar.section.submit.fail" />}
            onChange={handleConfirmCheckbox}
            autoComplete="off"
          />
        </Col>
      </Row>

      <Row className="dataPrivacy-row">
        <Col>
          <HeadingText size="sm">
            <Message id="dataErasure.section.note" />
          </HeadingText>
        </Col>
      </Row>
      <Row className="dataPrivacy-btn-row">
        <Col sm={6} md={6}>
          <Button
            theme="v2"
            id="continueBtn"
            size="ld"
            onClick={handleContinueClick}
            className="dataPrivacy-btn-fullwidth"
          >
            <Message id="dataErasure.section.continueButton" />
          </Button>
        </Col>
      </Row>
    </Fragment>
  )
})
DataDeletion.displayName = 'DataDeletion'
export default asASlide({ position: 0 })(DataDeletion)
